import ReactMarkdown from "react-markdown";
import { translate } from "../../core/i18n";
import gfm from 'remark-gfm';

export const ErrorMessage = ({ id, message }) => (
  <div id={id} className="alert alert-danger" role="alert" onClick={() => window.location.reload()}>
    {message}
  </div>
);

export const WarningMessage = ({ id, message }) => (
  <div id={id} className="alert alert-warning" role="alert">
    <span dangerouslySetInnerHTML={{ __html: message }} />
  </div>
);

export const TypingMessage = ({ id, user, message, color }) => (
  <div id={id}>
    <span style={{ color }}>{user}</span>:&nbsp;
    <i>{message}</i>
  </div>
);

export const ChatMessage = ({ id, user, message, color }) => (
  <div id={id}>
    <span style={{ color }}>{user}</span>:&nbsp;
    <ReactMarkdown className="chatMessage" children={message} remarkPlugins={[gfm]} />
  </div>
);

export const JumbotronMessage = ({ questions, onClick }) => (
  <p className="jumbotron-message chatMessage">
    <div className="jumbotron">
      <b>{translate("chat-example-question")}</b>
      <ul>
        {questions.map((question, index) => (
          <li key={index} onClick={() => onClick(question)}>
            {question}
          </li>
        ))}
      </ul>
      <div className="text-end">
        <button className="btn btn-sm btn-link" onClick={() => onClick()}>
          {translate("close")}
        </button>
      </div>
    </div>
  </p>
);

